import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { canonicalUrl } from '../config/seoRoutes.mjs';

/**
 * One self-referencing canonical for every route.
 *
 * The site had none at all, and the same build answers on four hostnames
 * (carsnus.com, www.carsnus.com, carsnus.pe, www.carsnus.pe), so Google was
 * free to pick its own representative URL out of every duplicate cluster —
 * which is exactly what "Duplicate without user-selected canonical" reports.
 *
 * Deliberately the only place in the app that renders rel="canonical": two
 * Helmet instances emitting one would race, and a page with two canonicals has
 * none as far as Google is concerned.
 */
function CanonicalTag() {
  const { pathname } = useLocation();
  const hostname = typeof window === 'undefined' ? '' : window.location.hostname;
  const href = canonicalUrl(pathname, hostname);



  return (
    <Helmet>
      <link rel='canonical' href={href} />
      <meta property='og:url' content={href} />
    </Helmet>
  );
}

export default CanonicalTag;
